import { usePaginatedQuery, useUrlPaginatedQuery } from "@shared/hooks";
import type { PaginatedQueryParams } from "@shared/api";

import {
  AdminLicenseInventoryFilters,
  ListAdminLicenseInventoryResponseItem,
} from "./licenseInventory.types";

export const ADMIN_LICENSE_INVENTORY_ENDPOINT = "v1/admin/license-inventory";
export const ADMIN_LICENSE_INVENTORY_QUERY_KEY = [
  "admin",
  "license-inventory",
];

const ADMIN_LICENSE_INVENTORY_FILTER_KEYS: (keyof AdminLicenseInventoryFilters)[] =
  ["complex", "structure", "module", "onlyActive", "sortBy", "sortOrder"];

export const useLicenseInventoryQuery = (
  params?: PaginatedQueryParams<AdminLicenseInventoryFilters>,
  options?: { enabled?: boolean },
) => {
  return usePaginatedQuery<
    ListAdminLicenseInventoryResponseItem,
    AdminLicenseInventoryFilters
  >({
    endpoint: ADMIN_LICENSE_INVENTORY_ENDPOINT,
    queryKeyBase: ADMIN_LICENSE_INVENTORY_QUERY_KEY,
    params,
    enabled: options?.enabled,
  });
};

export const useLicenseInventoryUrlQuery = () => {
  return useUrlPaginatedQuery<
    ListAdminLicenseInventoryResponseItem,
    AdminLicenseInventoryFilters
  >({
    endpoint: ADMIN_LICENSE_INVENTORY_ENDPOINT,
    queryKeyBase: ADMIN_LICENSE_INVENTORY_QUERY_KEY,
    filterKeys: ADMIN_LICENSE_INVENTORY_FILTER_KEYS,
  });
};
